import React from 'react';
import MasterExportContainer from 'common/entity/generic/MasterExportContainer';

class RiderExportContainer extends React.PureComponent {
    getAdditionalColumns = columnAccessors => {
        const { columns } = this.props;

        const workingDaysShown = columns.find(
            col => col.id === 'workingDays' && col.show
        );

        if (workingDaysShown) {
            // adding working days columns
            return columnAccessors.concat([
                'workingDays.slot',
                'workingDays.breaks',
                'workingDays.startLocation',
                'workingDays.endLocation',
                'workingDays.startLatitude',
                'workingDays.endLatitude',
                'workingDays.startLongitude',
                'workingDays.endLongitude'
            ]);
        }

        // Some unwanted columns are there with export need to sanitize

        return columnAccessors;
    };

    render() {
        return (
            <MasterExportContainer
                {...this.props}
                getAdditionalColumns={this.getAdditionalColumns}
            />
        );
    }
}

export default RiderExportContainer;
